import {
	IonList,
	IonItem,
	IonLabel,
	IonBadge,
	IonGrid,
	IonCol,
	IonRow,
} from "@ionic/react";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { deleteDatabase } from "workbox-core/_private";
import { getTodayString } from "../../../../services/util";

interface props {
	user: any;
	dates: any;
}

const DueNowEntryList: React.FC<props> = ({ user, dates }) => {
	const history = useHistory();
	const todayString = getTodayString();
	// useEffect(()=>{
	//   console.log(dates);
	// },[dates]);

	const _compareToday = (date: any) => {
		return date === todayString;
	};

	return (
		<>
			{dates &&
				dates
					.filter((el: any) => _compareToday(el.dateField))
					.map((el: any, idx: any) => (
						<IonItem
							button
							key={idx}
							onClick={() =>
								history.push(`/users/${user.uid}/entry/${el.timestamp}`)
							}
						>
							<IonGrid>
								<IonRow>
									<IonCol sizeLg="9" sizeMd="8" sizeXs="12">
										<IonLabel className="bold">{el.dateString}</IonLabel>
									</IonCol>
									<IonCol sizeLg="3" sizeMd="4" sizeXs="12">
										<IonBadge color="warning">Due Now</IonBadge>
									</IonCol>
								</IonRow>
							</IonGrid>
						</IonItem>
					))}
			{dates.filter((el: any) => _compareToday(el.dateField)).length < 1 && (
				<IonItem lines="none">
					<span>You're up to date!</span>
				</IonItem>
			)}
		</>
	);
};

export default DueNowEntryList;
